import { Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class serasaKeys extends MainKeys {
    get place() {
        return Places.mcSerasa
    }
}

export default serasaKeys
